import { createStore } from 'redux';
import rootReducer from '../reducers/index';

export default createStore(rootReducer);


// WEBPACK FOOTER //
// ./src/store/store.js